(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-bar"] && !Shopify.designMode) return;
  try {
    
  class PredictiveSearchBar extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('[data-predictive-search-input]');
      this.results = this.querySelector('[data-predictive-search-results]');
      this.clearButton = this.querySelector('[data-predictive-search-clear]');
      this.abortController = null;
      this.searchTerm = '';
      
      this.setupEventListeners();
    }

    setupEventListeners() {
      if (this.input) {
        this.input.addEventListener('input', this.debounce(this.onInput.bind(this), 300));
        this.input.addEventListener('focus', this.onFocus.bind(this));
      }

      if (this.clearButton) {
        this.clearButton.addEventListener('click', this.onClear.bind(this));
      }

      document.addEventListener('click', this.onClickOutside.bind(this));
    }

    onInput() {
      const searchTerm = this.input.value.trim();
      
      if (this.clearButton) {
        this.clearButton.hidden = searchTerm.length === 0;
      }

      if (searchTerm.length < 2) {
        this.hideResults();
        return;
      }

      this.searchTerm = searchTerm;
      this.getSearchResults(searchTerm);
    }

    onFocus() {
      if (this.searchTerm.length >= 2 && this.results.innerHTML.trim() !== '') {
        this.showResults();
      }
    }

    onClear() {
      this.input.value = '';
      this.searchTerm = '';
      this.clearButton.hidden = true;
      this.hideResults();
      this.input.focus();
    }

    onClickOutside(event) {
      if (!this.contains(event.target)) {
        this.hideResults();
      }
    }

    async getSearchResults(searchTerm) {
      if (this.abortController) {
        this.abortController.abort();
      }

      this.abortController = new AbortController();
      this.showLoading();

      try {
        const response = await fetch(
          `${window.Shopify.routes.root}search/suggest.json?q=${encodeURIComponent(searchTerm)}&resources[type]=product&resources[limit]=8`,
          { signal: this.abortController.signal }
        );

        if (!response.ok) throw new Error('Search failed');

        const data = await response.json();
        this.renderResults(data.resources.results.products, searchTerm);
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error('Search error:', error);
          this.hideResults();
        }
      }
    }

    renderResults(products, searchTerm) {
      if (!products || products.length === 0) {
        this.results.querySelector('.predictive-search-results__inner').innerHTML = `
          <p class="predictive-search__no-results">No products found for "${searchTerm}"</p>
        `;
        this.showResults();
        return;
      }

      const productsHtml = products.map(product => `
        <a href="${product.url}" class="predictive-search__item">
          ${product.image ? `
            <img 
              src="${product.image.replace(/(\.[^.]+)$/, '_200x200$1')}" 
              alt="${product.title}"
              class="predictive-search__item-image"
              loading="lazy"
              width="200"
              height="200"
            >
          ` : `
            <div class="predictive-search__item-image"></div>
          `}
          <h4 class="predictive-search__item-title">${product.title}</h4>
          <span class="predictive-search__item-price">${product.price}</span>
        </a>
      `).join('');

      this.results.querySelector('.predictive-search-results__inner').innerHTML = `
        <h3 class="predictive-search__heading">Products</h3>
        <div class="predictive-search__products">
          ${productsHtml}
        </div>
        <a href="${window.Shopify.routes.root}search?q=${encodeURIComponent(searchTerm)}&type=product" class="predictive-search__view-all">
          View all results
        </a>
      `;

      this.showResults();
    }

    showLoading() {
      this.results.querySelector('.predictive-search-results__inner').innerHTML = `
        <div class="predictive-search__spinner"></div>
      `;
      this.classList.add('predictive-search--loading');
      this.showResults();
    }

    showResults() {
      this.results.hidden = false;
    }

    hideResults() {
      this.results.hidden = true;
      this.classList.remove('predictive-search--loading');
    }

    debounce(fn, delay) {
      let timeoutId;
      return (...args) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => fn.apply(this, args), delay);
      };
    }
  }

  if (!customElements.get('predictive-search-bar')) {
    customElements.define('predictive-search-bar', PredictiveSearchBar);
  }

  } catch(e) { console.error(e); }
})();
})();
